import { Link } from 'react-router';
import { Trophy } from 'lucide-react';

export default function PrivacyPolicyPage() {
  return (
    <main className="min-h-screen bg-white text-neutral-900">
      <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(1400px_800px_at_50%_0%,rgba(0,102,255,0.06),transparent_70%)]" />
      </div>

      <header className="sticky top-0 z-50 border-b border-neutral-200/60 bg-white/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="relative h-11 w-11 rounded-2xl bg-gradient-to-br from-[#0066FF] to-[#00C7B1] text-white grid place-items-center font-bold text-base shadow-lg">
              <Trophy className="w-6 h-6" />
            </div>
            <span className="text-xl font-extrabold tracking-tight bg-gradient-to-r from-[#0066FF] to-[#00C7B1] bg-clip-text text-transparent">
              Turnivo
            </span>
          </Link>
          <Link
            to="/"
            className="text-sm font-medium text-neutral-600 hover:text-neutral-900 transition"
          >
            ← Strona główna
          </Link>
        </div>
      </header>

      <article className="mx-auto max-w-4xl px-6 py-12 md:py-16">
        <h1 className="text-4xl font-extrabold tracking-tight text-neutral-900 mb-2">
          Polityka prywatności
        </h1>
        <p className="text-neutral-500 text-sm mb-10">
          Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' })}
        </p>

        <div className="prose prose-neutral max-w-none space-y-8 text-neutral-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">1. Administrator danych</h2>
            <p>
              Administratorem Twoich danych osobowych w ramach serwisu Turnivo oraz platformy do organizacji turniejów siatkarskich (w tym panelu organizatora, wyników na żywo i powiązanych usług) jest operator serwisu Turnivo („Administrator”). Kontakt w sprawie danych osobowych: poprzez formularz lub adres e-mail podany na stronie turnivo.pl.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">2. Zakres i cele przetwarzania</h2>
            <p className="mb-3">Przetwarzamy dane osobowe w następujących celach:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Świadczenie usługi</strong> — rejestracja i logowanie, zarządzanie kontem (imię, nazwisko, adres e-mail, numer telefonu, adres, kod pocztowy, miejscowość), tworzenie i prowadzenie turniejów, drużyn, meczów, wyników na żywo, panelu sędziego oraz udostępnianie publicznych linków do wyników.</li>
              <li><strong>Rozliczenia i obsługa płatności</strong> — w przypadku wykupienia planu płatnego (Basic, Optimum, Premium) przetwarzamy dane niezbędne do wystawienia faktury i rozliczenia (np. dane do faktury, historia zamówień). Płatności mogą być realizowane przez zewnętrznego operatora (np. TPay); jego polityka prywatności obowiązuje w zakresie przetwarzania danych przy płatnościach.</li>
              <li><strong>Komunikacja i wsparcie</strong> — odpowiedzi na zapytania, powiadomienia e-mail (np. o turniejach, zmianach), opcjonalnie powiadomienia push w przeglądarce, jeśli je włączysz.</li>
              <li><strong>Bezpieczeństwo i zgodność z prawem</strong> — logi techniczne, ochrona przed nadużyciami, wykrywanie oszustw, realizacja obowiązków prawnych.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">3. Podstawa prawna</h2>
            <p>
              Przetwarzanie odbywa się na podstawie: wykonania umowy (art. 6 ust. 1 lit. b RODO) — w zakresie świadczenia usługi i rozliczeń; prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) — bezpieczeństwo, optymalizacja serwisu, analityka; Twojej zgody (art. 6 ust. 1 lit. a RODO) — tam, gdzie wyraźnie ją wyrażasz (np. newsletter, powiadomienia push). W przypadkach przewidzianych prawem możemy przetwarzać dane także w celu wykonania obowiązku prawnego (art. 6 ust. 1 lit. c RODO).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">4. Okres przechowywania</h2>
            <p>
              Dane przechowujemy przez okres niezbędny do realizacji usługi, rozliczeń, dochodzenia roszczeń oraz w zakresie wymaganym przepisami prawa (np. księgowe, podatkowe). Po zakończeniu umowy i wygaśnięciu obowiązków prawnych dane są usuwane lub anonimizowane, chyba że wyraziłeś zgodę na dalsze przetwarzanie (np. marketing).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">5. Udostępnianie danych</h2>
            <p>
              Dane mogą być udostępniane: dostawcom usług technicznych (hosting, e-mail, płatności), w granicach niezbędnych do realizacji usługi; organom państwa, gdy wynika to z przepisów prawa. Nie sprzedajemy Twoich danych osobowych. Publiczne treści (np. nazwy turniejów, drużyn, wyniki) udostępniane przez Ciebie w ramach „publicznego linku” są widoczne dla osób mających ten link.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">6. Prawa osób, których dane dotyczą</h2>
            <p className="mb-3">
              Przysługuje Ci prawo do: dostępu do swoich danych, sprostowania, usunięcia („prawo do bycia zapomnianym”), ograniczenia przetwarzania, przenoszenia danych, wniesienia sprzeciwu oraz cofnięcia zgody (nie wpływa to na zgodność z prawem przetwarzania przed cofnięciem). Możesz złożyć skargę do Prezesa Urzędu Ochrony Danych Osobowych (PUODO).
            </p>
            <p className="mb-3">
              Konto i powiązane dane możesz usunąć samodzielnie w panelu użytkownika. Instrukcja krok po kroku:{' '}
              <Link to="/usuniecie-konta" className="text-[#0066FF] font-semibold hover:underline">
                turnivo.pl/usuniecie-konta
              </Link>
              . W razie braku dostępu do konta napisz na kontakt@turnivo.pl.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">7. Pliki cookies i technologie śledzące</h2>
            <p>
              Serwis i panel mogą używać plików cookies oraz podobnych mechanizmów w celu: utrzymania sesji i logowania, zapamiętania ustawień, bezpieczeństwa oraz — za Twoją zgodą — analityki i dopasowania treści. Możesz zarządzać cookies w ustawieniach przeglądarki. Wyłączenie niezbędnych cookies może ograniczyć działanie serwisu (np. logowanie).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">8. Dane dzieci</h2>
            <p>
              Usługa jest kierowana do osób pełnoletnich lub do osób, które uzyskały zgodę opiekuna. Nie zbieramy świadomie danych dzieci poniżej 16 lat bez zgody rodzica lub opiekuna. W razie ustalenia takiego przypadku podejmiemy kroki w celu usunięcia danych.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mt-8 mb-3">9. Zmiany polityki</h2>
            <p>
              Administrator może aktualizować niniejszą politykę prywatności. O istotnych zmianach poinformujemy przez serwis lub e-mail. Kontynuowanie korzystania z usługi po wejściu w życie zmian oznacza akceptację zaktualizowanej polityki, o ile prawo nie wymaga osobnej zgody.
            </p>
          </section>
        </div>
      </article>

      <footer className="border-t border-neutral-200 bg-white mt-16">
        <div className="mx-auto flex max-w-4xl flex-col gap-4 px-6 py-8 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-2xl bg-gradient-to-br from-[#0066FF] to-[#00C7B1] text-white grid place-items-center font-bold text-sm shadow-lg">
              TU
            </div>
            <div>
              <div className="text-base font-extrabold">Turnivo</div>
              <div className="text-xs text-neutral-500">Organizacja turniejów siatkarskich</div>
            </div>
          </div>
          <div className="flex flex-wrap gap-4 text-sm text-neutral-500">
            <Link to="/" className="hover:text-neutral-900 transition">Strona główna</Link>
            <Link to="/regulamin" className="hover:text-neutral-900 transition">Regulamin</Link>
            <Link to="/usuniecie-konta" className="hover:text-neutral-900 transition">Usunięcie konta</Link>
            <Link to="/wsparcie" className="hover:text-neutral-900 transition">Wsparcie</Link>
            <span>© {new Date().getFullYear()} Turnivo</span>
          </div>
        </div>
      </footer>
    </main>
  );
}
